export class BaseLookup {
  name: string = '';
  items: NamedResponse[] = [];
}

export class NamedResponse {
  id: number = 0;
  name: string = '';
}
export class SharedProductDepartmentsResponse {
  id: number = 0;
  name: string = '';
  description: string = '';
  status: number = 0;
  companyId: number = 0;
  iconUrl: string = '';
  externalId: string = '';
  sortOrder: number = 0;
}

export class SharedProductCategoriesResponse {
  id: number = 0;
  name: string = '';
  description: string = '';
  status: number = 0;
  productCategoryTypeId: number = 0;
  companyId: number = 0;
  productDepartmentId: number = 0;
  productDepartmentName: string = '';
}

export class SharedUnitsResponse {
  id: number = 0;
  name: string = '';
  description: string = '';
  companyId: number = 0;
}

export class SharedBrandsResponse {
  id: number = 0;
  name: string = '';
  description: string = '';
  status: number = 0;
  companyId: number = 0;
}

export class SharedSuppliersResponse {
  id: number = 0;
  name: string = '';
  description: string = '';
  email: string = '';
  phoneNumber: string = '';
  status: number = 0;
  companyId: number = 0;
}
export class SharedCarriersResponse {
  id: number = 0;
  name: string = '';
  description: string = '';
  email: string = '';
  phoneNumber: string = '';
  status: number = 0;
  companyId: number = 0;
}
export class CarrierLiteResponse {
  id: number = 0;
  name: string = '';
  isDefault: boolean = false;
}
